var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"row":""}},[_c('v-col',{staticClass:"s8 input-field no-margins"},[(!_vm.valid)?_c('div',[_vm._v(" This page is not valid for this site group ")]):_c('div',{attrs:{"align":"center"}},[_c('PortfolioManagerTable',{attrs:{"randomKey":_vm.randomKey}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }